import type { ApiResponse } from '../services/SupabaseAPI'

// Helper function to check API response success
export const isSuccessResponse = <T>(response: ApiResponse<T>): response is ApiResponse<T> & { data: T } => {
  return response.status === 200 && response.data !== undefined && response.data !== null
}